import { useEffect } from "react";
import axios from "axios";
import { masterDataConfig } from "../../config/masterDataConfig";

const MasterDataLoader = ({ tableName, setMasterData, setLoadingOpt }) => {
  useEffect(() => {
    if (tableName) {
      loadMasterData();
    }
  }, [tableName]);

  // ==============================
  // BUILD OPTIONS (your original logic)
  // ==============================
  const buildOptions = (data = [], options = {}) => {
    const result = {};

    Object.entries(options || {}).forEach(([key, optionConfig]) => {
      const mapping = optionConfig?.option?.[0];
      const uniqueKey = optionConfig?.uniqueKey;

      if (!mapping) {
        console.error(
          `Invalid option configuration for "${key}"`,
          optionConfig,
        );
        return;
      }

      if (!uniqueKey) {
        console.error(`Missing uniqueKey for "${key}"`, optionConfig);
        return;
      }

      const uniqueMap = new Map();

      (data || []).forEach((row) => {
        const uniqueValue = row?.[uniqueKey];

        if (
          uniqueValue === undefined ||
          uniqueValue === null ||
          uniqueMap.has(uniqueValue)
        ) {
          return;
        }

        const item = {};

        Object.entries(mapping).forEach(([outputKey, sourceKey]) => {
          item[outputKey] = row?.[sourceKey];
        });

        uniqueMap.set(uniqueValue, item);
      });

      result[key] = Array.from(uniqueMap.values());
    });

    return result;
  };
  // ==============================
  // LOAD MASTER DATA
  // ==============================
  const loadMasterData = async () => {
    setLoadingOpt?.(true);

    try {
      const apiList = masterDataConfig?.[tableName] || [];

      if (!Array.isArray(apiList) || apiList.length === 0) {
        console.warn(`No master data config found for "${tableName}"`);
        setMasterData({});
        return;
      }

      const responses = await Promise.all(
        apiList.map((api) => axios.get(api.url)),
      );

      const masterData = {};

      responses.forEach((response, index) => {
        const config = apiList[index];
        const tempData = response?.data?.data.slice(0, 100) || [];

        if (config?.options) {
          const optionsData = buildOptions(tempData, config.options);

          Object.assign(masterData, optionsData);
        } else {
          masterData[config.key] = tempData;
        }
      });

      setMasterData(masterData);
    } catch (error) {
      console.error("Master Data Load Error:", error);
      setMasterData({});
    } finally {
      setLoadingOpt?.(false);
    }
  };

  return null;
};

export default MasterDataLoader;
